<div class="container-fluid container-fluid-limited">
  <h1 tabindex="-1" id="titreErreur">{{ 'coordonnees.titre' | translate }}</h1>
  <dsd-alert variant="inactive">
    <p>
      {{
        (estErreurSysteme
          ? 'pageErreur.messageErreurSysteme'
          : 'pageErreur.messageErreurFonctionNonDisponible'
        ) | translate
      }}
    </p>
  </dsd-alert>
</div>
<app-bouton-retour></app-bouton-retour>
